



































































































import { JournalApi } from "../api/JournalApi";
import JournalEntryLine from "./partials/JournalEntryLine.vue";
import Pagination from "../core/UI/Pagination.vue";
import JournalFilters from "./partials/Filters.vue";
import EntryDetails from "./entry_detail/EntryDetails.vue";
import { JournalEntry } from "../models/JournalEntry";
import AbsenceModal from "../employe/AbsenceModal.vue";
import UIActionType = JournalEntry.UIActionType;
import JournalEntryModal from "./JournalEntryModal.vue";
import MergeFoldersModal from "./MergeFoldersModal.vue";
import numeraInput from "../core/Forms/NumeraInput.vue";
import JournalTaskLine from "./partials/JournalTaskLine.vue";
import AutoRefresh from "../core/Table/AutoRefresh.vue";
import ExportButton from "../core/UI/ExportButton.vue";
import ConfirmSuppression from "../core/Modals/ConfirmSuppression";

export default {
    name: "Journal",
    components: {
        AutoRefresh,
        ExportButton,
        JournalTaskLine,
        MergeFoldersModal,
        JournalEntryModal,
        EntryDetails,
        JournalFilters,
        Pagination,
        JournalEntryLine,
        AbsenceModal,
    },
    props: {
        entryId: Number,
    },
    data() {
        return {
            entries: [],
            JournalApi: new JournalApi(),
            metadata: null,
            currentPage: 1,
            totalPages: 1,
            filters: { category: JournalEntry.ECategory.General },
            sort: "",
            selectedEntry: null,
            entryModal: {
                entryId: null,
                isNew: false,
                forceEditing: false,
            },
            addAbsenceModal: {
                show: false,
            },
            mergeFoldersModal: {
                show: false,
            },
        };
    },
    created() {
        let self = this;
        if (self.entryId) {
            self.JournalApi.get(self.entryId, { include: "comments" })
                .then(function (entry) {
                    self.selectEntry(entry);
                    // Au retour à la liste, rester dans la catégorie du
                    // dossier ouvert en lien direct.
                    self.filters = _.assign({}, self.filters, {
                        category: entry.category,
                    });
                })
                .catch(function () {
                    // Lien direct vers un dossier supprimé : retour liste.
                    self.refreshEntries();
                });
        } else {
            this.refreshEntries();
        }
    },
    methods: {
        loadPage(page: number) {
            let self = this;
            let params = {
                limit: 10,
                page: page,
                include: "comments,client.related_contacts",
                sort: this.sort,
            };
            params = _.assign(params, self.filters);
            return self.JournalApi.getAll(params).then(function (response) {
                let { data, metadata, paginator } = response;
                self.entries = data;
                self.totalPages = paginator.total_pages;
                self.currentPage = paginator.current_page;
                self.metadata = metadata;
                return self.entries;
            });
        },
        refreshEntries() {
            this.loadPage(this.currentPage);
        },
        selectEntry(entry: JournalEntry) {
            this.selectedEntry = entry;
            if (!this.selectedEntry) {
                this.refreshEntries();
            }
        },
        // Events
        createFolder(): void {
            this.entryModal.isNew = true;
        },
        editEntry(entry: JournalEntry): void {
            this.entryModal.entryId = entry.id;
            this.entryModal.forceEditing = true;
        },
        showEntry(entry: JournalEntry) {
            this.entryModal.entryId = entry.id;
        },
        onEntryModalClose(data): void {
            this.entryModal.forceEditing = false;
            this.entryModal.entryId = null;
            this.refreshEntries();
            if (data && data instanceof JournalEntry && this.entryModal.isNew) {
                this.selectEntry(data);
            }
            this.entryModal.isNew = false;
        },
        //
        showAbsenceModal(): void {
            this.addAbsenceModal.show = true;
        },
        onAbsenceModalClose(): void {
            this.addAbsenceModal.show = false;
            this.refreshEntries();
        },
        //
        showMergeFoldersModal(): void {
            this.mergeFoldersModal.show = true;
        },
        onMergeFoldersModalClose(): void {
            this.mergeFoldersModal.show = false;
            this.refreshEntries();
        },
        //
        updateFilters(filters): void {
            this.filters = filters;
        },
        updateSort(sort): void {
            this.sort = sort;
        },
        //
        doAction(action: JournalEntry.UIActionType, entry?: JournalEntry) {
            if (action === UIActionType.create_entry) {
                this.createFolder();
            } else if (action === JournalEntry.UIActionType.create_absence) {
                this.showAbsenceModal();
            } else if (action === JournalEntry.UIActionType.show_entry) {
                this.showEntry(entry);
            } else if (action === JournalEntry.UIActionType.edit_entry) {
                this.editEntry(entry);
            } else if (action === JournalEntry.UIActionType.delete_entry) {
                this.deleteFolder(entry);
            }
        },
        deleteFolder(entry: JournalEntry) {
            let self = this;
            ConfirmSuppression.demanderRaison(
                "Voulez vous supprimer ce dossier&nbsp;?",
                "Les commentaires du dossier seront également supprimés."
            ).then(function (raison) {
                if (raison === null) {
                    return;
                }
                self.JournalApi.delete(entry.id, raison)
                    .then(function () {
                        self.refreshEntries();
                        swal(
                            "Le dossier a bien été supprimé !",
                            "",
                            "success"
                        );
                    })
                    .catch(function (error) {
                        let data =
                            (error.response && error.response.data) || {};
                        swal(
                            "Suppression impossible",
                            data.message ||
                                (data.error && data.error.message) ||
                                "",
                            "error"
                        );
                    });
            });
        },
        getExportParams() {
            let self = this;
            let params = {
                sort: self.sort,
            };
            params = _.assign(params, self.filters);
            return params;
        },
    },
    watch: {
        filters: {
            deep: true,
            handler: function () {
                this.loadPage(1);
            },
        },
        sort: function () {
            this.loadPage(1);
        },
    },
};
